// 2026-11-02: typing to the Director is a text chat, never a call (Keaton: "it tries to fire up the voice chat"),
// and the composer behaves like Claude's and ChatGPT's. The pure parts, so they can be tested.
import type { DirectorStatus } from "./store";

/** A typed chat's state word: no mic is open, so never "Listening" or "Speaking". Null when not a live typed chat. */
export function typedWord(status: DirectorStatus, typed: boolean): string | null {
  if (!typed || status === "off" || status === "error") return null;
  return status === "connecting" ? "Connecting" : status === "thinking" ? "Thinking" : status === "speaking" ? "Writing" : "Text chat";
}

/** Whether a key press in the composer sends: Enter on a keyboard; Shift/Alt+Enter, an IME's Enter and a phone's
 *  return key (no Shift there) make a new line instead. */
export function enterSends(e: { key: string; shiftKey: boolean; altKey: boolean; isComposing: boolean }, coarsePointer: boolean): boolean {
  return e.key === "Enter" && !e.shiftKey && !e.altKey && !e.isComposing && !coarsePointer;
}
